export const BI_DIRECTIONAL_CHARGING_OPTIONS = [
  {label: 'V2L', value: 'V2L'},
  {label: 'V2H', value: 'V2H'},
  {label: 'V2G', value: 'V2G'},
  {label: 'V2V', value: 'V2V'},
  {label: 'V2X', value: 'V2X'},
] as const;
